<template>
  <div>
    <van-row>
      <van-col :span="18">
        <base-date v-model="queryCondition.begin_consult_date" label="起始日期" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="18">
        <base-date v-model="queryCondition.end_consult_date" label="结束日期" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="18">
        <base-select v-model="queryCondition.status" :options="CONST.CONSULT_STATUS" label="状态" />
      </van-col>
    </van-row>
    <van-row>
      <van-col :span="16">
        <base-input v-model="queryCondition.info" label="内容" />
      </van-col>
      <van-col :span="3" style="padding-top: 5px;">
        <base-button type="primary" @click="query">刷新</base-button>
      </van-col>
      <van-col :span="3" style="padding-top: 5px;">
        <base-button type="info" @click="add">新增</base-button>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="24" class="tip-msg">
        提示：点击记录，可查看明细！
      </van-col>
    </van-row>
    <van-row class="list-title">
      <van-col span="6">截止时间</van-col>
      <van-col span="4">状态</van-col>
      <van-col span="14">内容</van-col>
    </van-row>
    <template v-if="data && data.length > 0">
      <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
        <van-cell v-for="item in data" :key="item.id" class="list-tip"
                  @click="handleClick(item)">
          <van-col span="6" style="text-align: center;">{{ item.expiry_date }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.status_name }}</van-col>
          <van-col span="14" style="text-align: center;">{{ item.info }}</van-col>
        </van-cell>
      </van-pull-refresh>
      <van-tabbar safe-area-inset-bottom>
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
      </van-tabbar>
    </template>
    <template v-else>
      <van-col span="24" class="list-tip">{{ tip }}</van-col>
    </template>
  </div>
</template>

<script>
import { getSharedList } from '@/api/consultShared'
export default {
  name: 'ConsultSharedManage',
  data() {
    return {
      loading: false,
      data: [],
      tip: this.CONST.EMPTY_MSG,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        begin_consult_date: null,
        end_consult_date: null,
        status: null,
        phone: ''
      }
    }
  },
  mounted() {
    // 默认查一周内的
    const now = new Date()
    const begin_date = new Date()
    begin_date.setDate(now.getDate() - 7)
    this.queryCondition.begin_consult_date = this.Utils.df(begin_date)
    this.queryCondition.end_consult_date = this.Utils.df(now)
    this.query()
  },
  methods: {
    query() {
      this.tip = '查询中...'
      this.loading = true
      getSharedList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.data.forEach(row => {
          row.status_name = this.CONST.CONSULT_SHARED_STATUS.find(item => item.id === row.status).name
        })
        this.queryCondition.total = resp.total || 0
        if (this.data.length === 0) {
          this.tip = this.CONST.EMPTY_MSG
        }
        this.data.forEach(row => {
          if (row.last_detail_date) {
            const diff_time = parseInt(new Date().getTime() / 1000) - new Date(row.last_detail_date).getTime() / 1000
            row.diff_day = parseInt(diff_time / 60 / 60 / 24)
          } else {
            row.diff_day = ''
          }
        })
        this.loading = false
      }).catch(() => {
        this.tip = this.CONST.EMPTY_MSG
      })
    },
    add() {
      this.$store.dispatch('app/setSelectedShared', null)
      this.$router.push('/consult-shared/shared-edit')
    },
    handleClick(shared) {
      this.$store.dispatch('app/setSelectedShared', shared)
      this.$router.push('/consult-shared/shared-edit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/consult-shared/manage.vue